import * as _ from "lodash";
import DataGenerator from "../DataGenerator";
import {EntityType} from "@/shared/models/entityType";
import NodeBaseModel from "@/shared/models/abstract/nodeBaseModel";

export default class GroupModel extends NodeBaseModel {

    constructor() {
        super(EntityType.Group, "GROUP");

    }

    static fromJson(json) {
        if (json.entityType !== EntityType.Group) {
            throw new Error("Wrong deserialization data.");
        }
        let m = new GroupModel();
        m = _.assign(m, json);
        return m;
    }

    clone() {
        const clone = GroupModel.fromJson(this.toJson());
        clone.id = DataGenerator.id();
        return clone;
    }
};
